import { FormAsyncAutocomplete } from '../../../shared/ui/formAsyncAutocomplete'
import React from 'react'
import { useApi, useLogic } from '../../../../hooks/storeHook'
import { IntegrationType } from '../../../../server/mpsklad_core/Entity/IntegrationType'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { useFormContext } from 'react-hook-form'
import {
  integrationTypeNames,
  storeIntegrationKeyByType
} from '../../../../types/integrationTypeUtils'
import { useAttributeLoading } from '../lib/attributeLoadingContext'

// NOTE: This component is tightly coupled with ProductForm and is intended to be used strictly within its form context.
// It relies on the field structure and naming conventions defined in ProductForm.
// Therefore, it is located inside the form widget in the ui folder.

export const CategoriesSelector = () => {
  const logic = useLogic()

  const {setLoading} = useAttributeLoading()

  const api = useApi()

  const classes = useStyles()

  const {watch, setValue} = useFormContext()

  const [
    ozonSelected,
    wildberriesSelected,
    yandexMarketSelected
  ] = watch(['ozon.include', 'wildberries.include', 'yandexMarket.include'])

  const integrations = [
    {
      type: IntegrationType.Ozon,
      selected: ozonSelected,
      fieldName: 'ozon.category',
      integrationKey: storeIntegrationKeyByType[IntegrationType.Ozon]
    },
    {
      type: IntegrationType.Wildberries,
      selected: wildberriesSelected,
      fieldName: 'wildberries.category',
      integrationKey: storeIntegrationKeyByType[IntegrationType.Wildberries]
    },
    {
      type: IntegrationType.YandexMarket,
      selected: yandexMarketSelected,
      fieldName: 'yandexMarket.category',
      integrationKey: storeIntegrationKeyByType[IntegrationType.YandexMarket]
    }
  ]

  return (
    <Box display={'flex'} className={classes.wrapper}>
      {integrations.map(({type, selected, fieldName, integrationKey}) =>
        selected ? (
          <FormAsyncAutocomplete
            key={fieldName}
            name={fieldName}
            label={`Категория ${integrationTypeNames[type]}`}
            placeholder="Выберите категорию..."
            required
            fetchOptions={async (input) =>
              await logic.loadIntegrationCategories(type, input)
            }
            types={[integrationKey]}
            onSelected={async (category) => {
              setLoading(type, true)

              try {
                const attributes = await api.productCategory.getCategoryAttributes(category.id)

                const targetField = {
                  [IntegrationType.Ozon]: 'ozon.attributes',
                  [IntegrationType.Wildberries]: 'wildberries.attributes',
                  [IntegrationType.YandexMarket]: 'yandexMarket.attributes',
                  [IntegrationType.MoySklad]: 'yandexMarket.attributes'
                }[type]

                setValue(targetField, attributes)
              } finally {
                setLoading(type, false)
              }
            }}
          />
        ) : null
      )}
    </Box>
  )
}

const useStyles = makeStyles(
  {
    wrapper: {
      maxWidth: '800px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      marginBottom: '20px'
    }
  })